// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center[data-v-71b12149]{\n    display: flex;\n    align-self: center;\n    height: 100%;\n    align-items: center;\n    padding-bottom: 300px;\n    flex-direction: column;\n    justify-content: center;\n}\n.i[data-v-71b12149], .b[data-v-71b12149]{\n    margin-top:20px\n}\n", ""]);
// Exports
module.exports = exports;
